import { defineStore } from 'pinia';
import { ref, type Ref } from 'vue';
import { isUndefinedOrEmpty } from '@/helpers/helpers';
import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

export const useSessionStore = defineStore('session', () => {
    // state
    const sid: Ref<string> = ref('');

    function createSID() {
        const sidCookie = Cookies.get('userSid');
        let sidValue = '';

        if (!isUndefinedOrEmpty(sidCookie)) {
            sidValue = sidCookie!.toString();
        } else {
            sidValue = uuidv4().toString();
            Cookies.set('userSid', sidValue, { secure: false });
        }

        sid.value = sidValue;
    }

    return {
        sid,
        createSID
    };
});
